import React, { PropTypes } from 'react';
import last from 'lodash/last';

import Project from 'project/containers/project';
import LandingPage from 'landing_pages/containers';

const Wrapper = ({ params, children }) => {
  const lastPart = last(params.pageSlug.split('-'));
  const hasProjectId = parseInt(lastPart, 10);

  if (hasProjectId) {
    return (<Project>{children}</Project>);
  }

  return <LandingPage />;
};

Wrapper.propTypes = {
  children: PropTypes.any,
  params: PropTypes.object.isRequired,
};

export default Wrapper;



// WEBPACK FOOTER //
// ./landing_pages/components/wrapper.jsx